import { useState } from 'react';
import PropTypes from 'prop-types';
import { BiCommentDots } from 'react-icons/bi';

const MAX_STRING_LENGTH = 111;

const CommentsHistory = ({ observacion }) => {
  const [truncateText, setTruncateText] = useState(false);

  const truncate = (text) => (
    <div>
      {!truncateText ? `${text?.substring(0, 110)}... ` : text}
      <button
        className="button_see_more"
        onClick={() => setTruncateText(!truncateText)}
        type="button"
      >
        {!truncateText ? 'VER MÁS' : 'VER MENOS'}
      </button>
    </div>
  );
  const observationTruncate = truncate(observacion);
  const observationText =
    observacion?.length > MAX_STRING_LENGTH ? observationTruncate : observacion;

  return (
    <div className="comment_wrapper">
      <div className="comment_line" />
      <div className="comment_comment_wrapper">
        <div className="comment_comment_icon">
          <BiCommentDots />
        </div>
        {observacion && <div className="comment_comment_text">{observationText}</div>}
      </div>
    </div>
  );
};

CommentsHistory.propTypes = {
  observacion: PropTypes.string.isRequired
};

export default CommentsHistory;
